import { t } from '@app/i18n';
import { PageHeader } from '@zarya/ui';
import { EnvironmentsCard } from '../TenantSettings/EnvironmentsCard';

export function EnvironmentsPage() {
  return (
    <>
      <PageHeader
        title={t('tenantSettings.environments.page.title')}
        tip={t('tenantSettings.environments.page.purpose')}
        icon="gear"
      />
      <EnvironmentsCard />
    </>
  );
}
